<template>
  <add-ic-call v-if="valueName == 'add_ic_call'" />
  <alternate-email v-else-if="valueName == 'alternate_email'" />
  <business v-else-if="valueName == 'business'" />
  <call v-else-if="valueName == 'call'" />
  <call-end v-else-if="valueName == 'call_end'" />
  <call-made v-else-if="valueName == 'call_made'" />
  <call-merge v-else-if="valueName == 'call_merge'" />
  <call-missed v-else-if="valueName == 'call_missed'" />
  <call-missed-outgoing v-else-if="valueName == 'call_missed_outgoing'" />
  <call-received v-else-if="valueName == 'call_received'" />
  <call-split v-else-if="valueName == 'call_split'" />
  <cancel-presentation v-else-if="valueName == 'cancel_presentation'" />
  <chat v-else-if="valueName == 'chat'" />
  <chat-bubble v-else-if="valueName == 'chat_bubble'" />
  <chat-bubble-outline v-else-if="valueName == 'chat_bubble_outline'" />
  <clear-all v-else-if="valueName == 'clear_all'" />
  <comment v-else-if="valueName == 'comment'" />
  <contact-mail v-else-if="valueName == 'contact_mail'" />
  <contact-phone v-else-if="valueName == 'contact_phone'" />
  <contacts v-else-if="valueName == 'contacts'" />
  <desktop-access-disabled v-else-if="valueName == 'desktop_access_disabled'" />
  <dialer-sip v-else-if="valueName == 'dialer_sip'" />
  <dialpad v-else-if="valueName == 'dialpad'" />
  <domain-disabled v-else-if="valueName == 'domain_disabled'" />
  <domain-verification v-else-if="valueName == 'domain_verification'" />
  <duo v-else-if="valueName == 'duo'" />
  <email v-else-if="valueName == 'email'" />
  <forum v-else-if="valueName == 'forum'" />
  <forward-to-inbox v-else-if="valueName == 'forward_to_inbox'" />
  <hourglass-bottom v-else-if="valueName == 'hourglass_bottom'" />
  <hourglass-top v-else-if="valueName == 'hourglass_top'" />
  <import-contacts v-else-if="valueName == 'import_contacts'" />
  <import-export v-else-if="valueName == 'import_export'" />
  <invert-colors-off v-else-if="valueName == 'invert_colors_off'" />
  <list-alt v-else-if="valueName == 'list_alt'" />
  <live-help v-else-if="valueName == 'live_help'" />
  <location-off v-else-if="valueName == 'location_off'" />
  <location-on v-else-if="valueName == 'location_on'" />
  <mail-outline v-else-if="valueName == 'mail_outline'" />
  <mark-chat-read v-else-if="valueName == 'mark_chat_read'" />
  <mark-chat-unread v-else-if="valueName == 'mark_chat_unread'" />
  <mark-email-read v-else-if="valueName == 'mark_email_read'" />
  <mark-email-unread v-else-if="valueName == 'mark_email_unread'" />
  <message v-else-if="valueName == 'message'" />
  <mobile-screen-share v-else-if="valueName == 'mobile_screen_share'" />
  <more-time v-else-if="valueName == 'more_time'" />
  <nat v-else-if="valueName == 'nat'" />
  <no-sim v-else-if="valueName == 'no_sim'" />
  <pause-presentation v-else-if="valueName == 'pause_presentation'" />
  <person-add-disabled v-else-if="valueName == 'person_add_disabled'" />
  <person-search v-else-if="valueName == 'person_search'" />
  <phone v-else-if="valueName == 'phone'" />
  <phone-disabled v-else-if="valueName == 'phone_disabled'" />
  <phone-enabled v-else-if="valueName == 'phone_enabled'" />
  <phonelink-erase v-else-if="valueName == 'phonelink_erase'" />
  <phonelink-lock v-else-if="valueName == 'phonelink_lock'" />
  <phonelink-ring v-else-if="valueName == 'phonelink_ring'" />
  <phonelink-setup v-else-if="valueName == 'phonelink_setup'" />
  <portable-wifi-off v-else-if="valueName == 'portable_wifi_off'" />
  <present-to-all v-else-if="valueName == 'present_to_all'" />
  <print-disabled v-else-if="valueName == 'print_disabled'" />
  <qr-code v-else-if="valueName == 'qr_code'" />
  <qr-code-scanner v-else-if="valueName == 'qr_code_scanner'" />
  <read-more v-else-if="valueName == 'read_more'" />
  <ring-volume v-else-if="valueName == 'ring_volume'" />
  <rss-feed v-else-if="valueName == 'rss_feed'" />
  <screen-share v-else-if="valueName == 'screen_share'" />
  <sentiment-satisfied-alt v-else-if="valueName == 'sentiment_satisfied_alt'" />
  <speaker-phone v-else-if="valueName == 'speaker_phone'" />
  <stay-current-landscape v-else-if="valueName == 'stay_current_landscape'" />
  <stay-current-portrait v-else-if="valueName == 'stay_current_portrait'" />
  <stay-primary-landscape v-else-if="valueName == 'stay_primary_landscape'" />
  <stay-primary-portrait v-else-if="valueName == 'stay_primary_portrait'" />
  <stop-screen-share v-else-if="valueName == 'stop_screen_share'" />
  <swap-calls v-else-if="valueName == 'swap_calls'" />
  <textsms v-else-if="valueName == 'textsms'" />
  <unsubscribe v-else-if="valueName == 'unsubscribe'" />
  <voicemail v-else-if="valueName == 'voicemail'" />
  <vpn-key v-else-if="valueName == 'vpn_key'" />
  <wifi-calling v-else-if="valueName == 'wifi_calling'" />
</template>

<script>
import AddIcCall from "@/components/Icons/Communication/AddIcCall";
import AlternateEmail from "@/components/Icons/Communication/AlternateEmail";
import Business from "@/components/Icons/Communication/Business";
import Call from "@/components/Icons/Communication/Call";
import CallEnd from "@/components/Icons/Communication/CallEnd";
import CallMade from "@/components/Icons/Communication/CallMade";
import CallMerge from "@/components/Icons/Communication/CallMerge";
import CallMissed from "@/components/Icons/Communication/CallMissed";
import CallMissedOutgoing from "@/components/Icons/Communication/CallMissedOutgoing";
import CallReceived from "@/components/Icons/Communication/CallReceived";
import CallSplit from "@/components/Icons/Communication/CallSplit";
import CancelPresentation from "@/components/Icons/Communication/CancelPresentation";
import Chat from "@/components/Icons/Communication/Chat";
import ChatBubble from "@/components/Icons/Communication/ChatBubble";
import ChatBubbleOutline from "@/components/Icons/Communication/ChatBubbleOutline";
import ClearAll from "@/components/Icons/Communication/ClearAll";
import Comment from "@/components/Icons/Communication/Comment";
import ContactMail from "@/components/Icons/Communication/ContactMail";
import ContactPhone from "@/components/Icons/Communication/ContactPhone";
import Contacts from "@/components/Icons/Communication/Contacts";
import DesktopAccessDisabled from "@/components/Icons/Communication/DesktopAccessDisabled";
import DialerSip from "@/components/Icons/Communication/DialerSip";
import Dialpad from "@/components/Icons/Communication/Dialpad";
import DomainDisabled from "@/components/Icons/Communication/DomainDisabled";
import DomainVerification from "@/components/Icons/Communication/DomainVerification";
import Duo from "@/components/Icons/Communication/Duo";
import Email from "@/components/Icons/Communication/Email";
import Forum from "@/components/Icons/Communication/Forum";
import ForwardToInbox from "@/components/Icons/Communication/ForwardToInbox";
import HourglassBottom from "@/components/Icons/Communication/HourglassBottom";
import HourglassTop from "@/components/Icons/Communication/HourglassTop";
import ImportContacts from "@/components/Icons/Communication/ImportContacts";
import ImportExport from "@/components/Icons/Communication/ImportExport";
import InvertColorsOff from "@/components/Icons/Communication/InvertColorsOff";
import ListAlt from "@/components/Icons/Communication/ListAlt";
import LiveHelp from "@/components/Icons/Communication/LiveHelp";
import LocationOff from "@/components/Icons/Communication/LocationOff";
import LocationOn from "@/components/Icons/Communication/LocationOn";
import MailOutline from "@/components/Icons/Communication/MailOutline";
import MarkChatRead from "@/components/Icons/Communication/MarkChatRead";
import MarkChatUnread from "@/components/Icons/Communication/MarkChatUnread";
import MarkEmailRead from "@/components/Icons/Communication/MarkEmailRead";
import MarkEmailUnread from "@/components/Icons/Communication/MarkEmailUnread";
import Message from "@/components/Icons/Communication/Message";
import MobileScreenShare from "@/components/Icons/Communication/MobileScreenShare";
import MoreTime from "@/components/Icons/Communication/MoreTime";
import Nat from "@/components/Icons/Communication/Nat";
import NoSim from "@/components/Icons/Communication/NoSim";
import PausePresentation from "@/components/Icons/Communication/PausePresentation";
import PersonAddDisabled from "@/components/Icons/Communication/PersonAddDisabled";
import PersonSearch from "@/components/Icons/Communication/PersonSearch";
import Phone from "@/components/Icons/Communication/Phone";
import PhoneDisabled from "@/components/Icons/Communication/PhoneDisabled";
import PhoneEnabled from "@/components/Icons/Communication/PhoneEnabled";
import PhonelinkErase from "@/components/Icons/Communication/PhonelinkErase";
import PhonelinkLock from "@/components/Icons/Communication/PhonelinkLock";
import PhonelinkRing from "@/components/Icons/Communication/PhonelinkRing";
import PhonelinkSetup from "@/components/Icons/Communication/PhonelinkSetup";
import PortableWifiOff from "@/components/Icons/Communication/PortableWifiOff";
import PresentToAll from "@/components/Icons/Communication/PresentToAll";
import PrintDisabled from "@/components/Icons/Communication/PrintDisabled";
import QrCode from "@/components/Icons/Communication/QrCode";
import QrCodeScanner from "@/components/Icons/Communication/QrCodeScanner";
import ReadMore from "@/components/Icons/Communication/ReadMore";
import RingVolume from "@/components/Icons/Communication/RingVolume";
import RssFeed from "@/components/Icons/Communication/RssFeed";
import ScreenShare from "@/components/Icons/Communication/ScreenShare";
import SentimentSatisfiedAlt from "@/components/Icons/Communication/SentimentSatisfiedAlt";
import SpeakerPhone from "@/components/Icons/Communication/SpeakerPhone";
import StayCurrentLandscape from "@/components/Icons/Communication/StayCurrentLandscape";
import StayCurrentPortrait from "@/components/Icons/Communication/StayCurrentPortrait";
import StayPrimaryLandscape from "@/components/Icons/Communication/StayPrimaryLandscape";
import StayPrimaryPortrait from "@/components/Icons/Communication/StayPrimaryPortrait";
import StopScreenShare from "@/components/Icons/Communication/StopScreenShare";
import SwapCalls from "@/components/Icons/Communication/SwapCalls";
import Textsms from "@/components/Icons/Communication/Textsms";
import Unsubscribe from "@/components/Icons/Communication/Unsubscribe";
import Voicemail from "@/components/Icons/Communication/Voicemail";
import VpnKey from "@/components/Icons/Communication/VpnKey";
import WifiCalling from "@/components/Icons/Communication/WifiCalling";

export default {
  components: {
    AddIcCall,
    AlternateEmail,
    Business,
    Call,
    CallEnd,
    CallMade,
    CallMerge,
    CallMissed,
    CallMissedOutgoing,
    CallReceived,
    CallSplit,
    CancelPresentation,
    Chat,
    ChatBubble,
    ChatBubbleOutline,
    ClearAll,
    Comment,
    ContactMail,
    ContactPhone,
    Contacts,
    DesktopAccessDisabled,
    DialerSip,
    Dialpad,
    DomainDisabled,
    DomainVerification,
    Duo,
    Email,
    Forum,
    ForwardToInbox,
    HourglassBottom,
    HourglassTop,
    ImportContacts,
    ImportExport,
    InvertColorsOff,
    ListAlt,
    LiveHelp,
    LocationOff,
    LocationOn,
    MailOutline,
    MarkChatRead,
    MarkChatUnread,
    MarkEmailRead,
    MarkEmailUnread,
    Message,
    MobileScreenShare,
    MoreTime,
    Nat,
    NoSim,
    PausePresentation,
    PersonAddDisabled,
    PersonSearch,
    Phone,
    PhoneDisabled,
    PhoneEnabled,
    PhonelinkErase,
    PhonelinkLock,
    PhonelinkRing,
    PhonelinkSetup,
    PortableWifiOff,
    PresentToAll,
    PrintDisabled,
    QrCode,
    QrCodeScanner,
    ReadMore,
    RingVolume,
    RssFeed,
    ScreenShare,
    SentimentSatisfiedAlt,
    SpeakerPhone,
    StayCurrentLandscape,
    StayCurrentPortrait,
    StayPrimaryLandscape,
    StayPrimaryPortrait,
    StopScreenShare,
    SwapCalls,
    Textsms,
    Unsubscribe,
    Voicemail,
    VpnKey,
    WifiCalling,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
